import { memo } from "react";
import type { IconProps } from "types";

const Import = ({ width = "19", height = "20" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.625 11.875V15.0417C16.625 15.4616 16.4582 15.8643 16.1613 16.1613C15.8643 16.4582 15.4616 16.625 15.0417 16.625H3.95833C3.53841 16.625 3.13568 16.4582 2.83875 16.1613C2.54181 15.8643 2.375 15.4616 2.375 15.0417V11.875"
      stroke="currentColor"
      strokeWidth="1.58333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.54167 7.91663L9.5 11.875L13.4583 7.91663"
      stroke="currentColor"
      strokeWidth="1.58333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 11.875V2.375"
      stroke="currentColor"
      strokeWidth="1.58333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(Import);
